import React, {useContext, useState, createContext} from 'react';
import _isNil from "lodash-es/isNil"
import { useQuery, useApolloClient } from '@apollo/client';

import { SIGN_IN, CURRENT_USER, CHANGE_PASSWORD, VALIDATE_USER_EMAIL } from 'query'


const ClientUserContext = createContext(null);

const ClientUserProvider = ({children}) => {
  const apolloClient = useApolloClient();
  const [mainLoading, setMainLoading] = useState(true)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [clientUserData, setClientUserData] = useState({})

  //auto load "user data"
  useQuery(CURRENT_USER, {
    fetchPolicy: "no-catch",
    onError(err){
      setMainLoading(false)
    },
    onCompleted(userData) {
      if(!_isNil(userData.currentUser)){
        setClientUserData(userData.currentUser)
        setIsLoggedIn(true)
      }
      setMainLoading(false)
    }
  });

  const signIn = async (email, password) => {
    try{
      let result = await apolloClient.mutate({
        mutation: SIGN_IN,
        variables: {email, password},
      })

      if(result.data.signIn === null) {
        alert('Wrong Password')
        return
      }
      localStorage.setItem('@bereachAuthToken', result.data.signIn.token)
      delete result.data.signIn.token
      setClientUserData(result.data.signIn)
      setIsLoggedIn(true)
      setMainLoading(false)
    } catch (err){
      console.error("ClientUserProvider signIn", err)
      alert(err)
      setMainLoading(false)
      throw err
    }
  }

  const signOut = async () => {
    localStorage.removeItem("@bereachAuthToken");
    setClientUserData(null)
    setIsLoggedIn(false)
  }

  const changePassword = async (password) => {
    try{
      await apolloClient.mutate({
        mutation: CHANGE_PASSWORD,
        variables: {password:password},
      })
      return
    } catch (err){
      console.error("ClientUserProvider changePassword", err)
      setMainLoading(false)
      throw err
    }
  }

  const validateUserEmail = async (input) => {
    try{
      const result = await apolloClient.mutate({
        mutation: VALIDATE_USER_EMAIL,
        variables: { input },
      });

      return result?.data?.validateUserEmail || null;
    } catch (err){
      console.error("ClientUserProvider validateUserEmail", err?.message)
      throw err
    }
  }

  return (
    <ClientUserContext.Provider
      value={{
        setMainLoading,
        mainLoading,
        isLoggedIn,
        clientUserData,
        setClientUserData,
        signIn,
        signOut,
        changePassword,
        validateUserEmail,
      }}>
      {children}
    </ClientUserContext.Provider>
  );
};

const useClientUser = () => {
  const clientUser = useContext(ClientUserContext);
  if (clientUser == null) {
    throw new Error('clientUser() called outside of a AuthProvider?');
  }
  return clientUser;
};

export {ClientUserProvider, useClientUser};


